import {
  CONVENIENCE_DOOR_TABLE_KEY,
  CONVENIENCE_TABLE_KEY,
} from 'constants/tableQueryKeys'
import { ConvenienceTable } from './ConvenienceTable/ConvenienceTable'
import { useState } from 'react'
import { Switch } from 'components/UI/Switch/Switch'
import { StandardSummaryResponse } from 'models/paginated-response'
import { ConvenienceDoorTable } from '../ConvenienceDoors/ConvenienceDoorsTable/ConvenienceDoorsTable'

export function ConvenienceChainDoorTable({
  pageParamName,
  setConvenienceCount,
}: {
  pageParamName: string
  setConvenienceCount: (count: StandardSummaryResponse) => void
}) {
  const [showChainTable, setShowChainTable] = useState(true)
  return (
    <>
      {showChainTable ? (
        <ConvenienceTable
          pageParamName={`${pageParamName}-chain-page`}
          tableKey={CONVENIENCE_TABLE_KEY}
          setTotalRowsCount={setConvenienceCount}
          AfterSearchComponent={
            <Switch
              type={'checkbox'}
              checked={showChainTable}
              onChange={(e) => {
                if (e.target.checked) {
                  setShowChainTable(true)
                } else {
                  setShowChainTable(false)
                }
              }}
              labelRight={showChainTable ? 'Chain View' : 'Door View'}
              className={'min-w-[120px]'}
            />
          }
        />
      ) : (
        <ConvenienceDoorTable
          pageParamName={`${pageParamName}-door-page`}
          tableKey={CONVENIENCE_DOOR_TABLE_KEY}
          setTotalRowsCount={(count) =>
            setConvenienceCount({
              // Since they share the same component for showing doors and chains count
              // the value is swapped for the doors table, where the alt_count is the chains count
              count: count.alt_count,
              alt_count: count.count,
            })
          }
          AfterSearchComponent={
            <Switch
              type={'checkbox'}
              checked={showChainTable}
              onChange={(e) => {
                if (e.target.checked) {
                  setShowChainTable(true)
                } else {
                  setShowChainTable(false)
                }
              }}
              labelRight={showChainTable ? 'Chain View' : 'Door View'}
              className={'min-w-[120px]'}
            />
          }
        />
      )}
    </>
  )
}
